import Vue from 'vue'
import Resource from 'vue-resource'
import store from '@/store'
Vue.use(Resource)

export default {
	create (data) {
		return new Promise(function (resolve, reject) {
			Vue.http.post(store.state.apiURL + '/v1/payment/relations', data).then(function (response) {
				resolve(response.body)
			}, function (response) {
				reject(response)
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/payment/relation.js